<template>
    <form class="ClientCommentForm form-inline">
        <div class="ClientCommentForm__formGroup form-group">
            <label for="comment" class="sr-only">Comment:</label>
            <textarea class="ClientCommentForm__formControl form-control" rows="5" id="comment" v-model="comment" placeholder="Write a reply..."></textarea>
        </div>
        <button-cta class="ClientCommentForm__button" :onClick="handleComment">Send</button-cta>
    </form>
</template>

<script>
import ButtonCta from '@/components/Button/button'
export default {
  name: 'ClientCommentForm',
  components: {
    ButtonCta
  },
  props: {
    updateNotification: Function
  },
  mounted () {},
  computed: {},
  data: () => ({
    comment: null
  }),
  methods: {
    handleComment () {
      if (this.comment === null || this.comment === '') {
        this.updateNotification('Your reply cannot be empty. Please try again.')
        return
      }
      this.updateNotification(null)
    }
  }
}
</script>

<style lang="scss">
  .ClientCommentForm {
      display: flex;
      align-items: flex-start;
      &__formGroup {
          width: 100%
      }
      &__formControl {
          width: 100% !important;
      }
      &__button {
          margin-left: 10px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/ClientComments/client-comment-form.vue